import { jsx } from "react/jsx-runtime";
import { useVirtualizer } from "@tanstack/react-virtual";
import classnames from "../../utils/classnames.js";
import DealersListItem from "./DealersListItem.js";
import './DealersList.css';/* empty css                 */
const DealersList = ({
  className,
  items,
  hovered,
  onSelect,
  onMouseOut,
  onMouseIn,
  itemDataAttributes,
  estimatedItemSize = 108,
  containerRef
}) => {
  var _a;
  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => containerRef == null ? void 0 : containerRef.current,
    estimateSize: () => estimatedItemSize
  });
  const virtualItems = virtualizer.getVirtualItems();
  const translateY = ((_a = virtualItems == null ? void 0 : virtualItems[0]) == null ? void 0 : _a.start) ?? 0;
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealers-list", className), ref: containerRef, children: /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        height: virtualizer.getTotalSize(),
        width: "100%",
        position: "relative"
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            transform: `translateY(${translateY}px)`
          },
          children: virtualItems.map((virtualItem) => {
            const item = items[virtualItem.index];
            const { id, title, description, address, phone, tags, brand } = item;
            return /* @__PURE__ */ jsx(
              DealersListItem,
              {
                id,
                title,
                description,
                address,
                phone,
                brand,
                tags: tags || [],
                isHovered: id === hovered,
                onMouseIn,
                onMouseOut,
                onSelect,
                ...itemDataAttributes == null ? void 0 : itemDataAttributes(item)
              },
              id
            );
          })
        }
      )
    }
  ) });
};
DealersList.Item = DealersListItem;
export {
  DealersList as default
};
//# sourceMappingURL=DealersList.js.map
